import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import Aura from '@primeng/themes/aura';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth.service';
import { MockAuthService } from './services-mock/mock-auth.service';
import { AvatarService } from './services/avatar.service';
import { MockAvatarService } from './services-mock/mock-avatar.service';
import { SettingsService } from './services/settings.service';
import { MockSettingsService } from './services-mock/mock-settings.service';
import { TenantService } from './services/tenant.service';
import { MockTenantService } from './services-mock/mock-tenant.service';
import { WorkspaceService } from './services/workspace.service';
import { MockWorkspaceService } from './services-mock/mock-workspace.service';
import { ConferenceService } from './services/conference.service';
import { MockConferenceService } from './services-mock/mock-conference.service';
import { AttendeeService } from './services/attendee.service';
import { MockAttendeeService } from './services-mock/mock-attendee.service';
import { VendorService } from './services/vendor.service';
import { MockVendorService } from './services-mock/mock-vendor.service';
import { PostService } from './services/post.service';
import { MockPostService } from './services-mock/mock-post.service';
import { LeaderboardService } from './services/leaderboard.service';
import { MockLeaderboardService } from './services-mock/mock-leaderboard.service';
import { OrganizationService } from './services/organization.service';
import { MockOrganizationService } from './services-mock/mock-organization.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
    BrowserAnimationsModule,
    provideHttpClient(),
    // Conditionally provide mock or non-mock services based on environment
    {
      provide: AuthService,
      useClass: environment.mock ? MockAuthService : AuthService,
    },
    {
      provide: AvatarService,
      useClass: environment.mock ? MockAvatarService : AvatarService,
    },
    {
      provide: SettingsService,
      useClass: environment.mock ? MockSettingsService : SettingsService,
    },
    {
      provide: TenantService,
      useClass: environment.mock ? MockTenantService : TenantService,
    },
    {
      provide: WorkspaceService,
      useClass: environment.mock ? MockWorkspaceService : WorkspaceService,
    },
    {
      provide: ConferenceService,
      useClass: environment.mock ? MockConferenceService : ConferenceService,
    },
    {
      provide: AttendeeService,
      useClass: environment.mock ? MockAttendeeService : AttendeeService,
    },
    {
      provide: VendorService,
      useClass: environment.mock ? MockVendorService : VendorService,
    },
    {
      provide: PostService,
      useClass: environment.mock ? MockPostService : PostService,
    },
    {
      provide: LeaderboardService,
      useClass: environment.mock ? MockLeaderboardService : LeaderboardService,
    },
    {
      provide: OrganizationService,
      useClass: environment.mock ? MockOrganizationService : OrganizationService,
    },
  ],
};
